export const SegmentsColConfig = [
  {
    name_of_db_column: 'segmentName',
    label_of_column: 'Segment Name',
    order_of_column: 1,
    columnFilterPlaceholder: 'Segment Name',
  },
]
